import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '@lib/env';
import { Observable } from 'rxjs';
import { UriBuilder } from 'uribuilder';
import { FrameworkAgreement } from './SupplierFrameworkAgreement';
import { HttpExtras } from '@lib/core';

@Injectable({
    providedIn: 'root',
})
export class SupplierFrameworkAgreementDataService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);

    public getAllSupplierFrameworkAgreement(supplierCompanyId: string): Observable<FrameworkAgreement[]> {
        const uri: UriBuilder = this.env.getBase('demand', 'supplier-framework-agreement', supplierCompanyId);
        return this.http.get<FrameworkAgreement[]>(uri.toString(), {
            params: HttpExtras.IGNORE_CACHE,
        });
    }

    public deleteSupplierFrameworkAgreement(
        demandId: string,
        supplierCompanyId: string,
        newFrameworkAgreement: FrameworkAgreement,
    ): Observable<void> {
        const url = this.env.getBase(
            'demand',
            demandId,
            'supplier',
            supplierCompanyId,
            'framework-agreement',
            newFrameworkAgreement.id,
        );

        return this.http.delete<void>(url.toString());
    }

    public updateSupplierFrameworkAgreement(
        demandId: string,
        supplierCompanyId: string,
        newFrameworkAgreement: FrameworkAgreement,
    ): Observable<void> {
        const uri: UriBuilder = this.env.getBase(
            'demand',
            demandId,
            'supplier',
            supplierCompanyId,
            'framework-agreement',
            newFrameworkAgreement.id,
        );

        return this.http.post<void>(uri.toString(), newFrameworkAgreement);
    }
}
